/**
 * Marcas do cadastro de produto — funções PURAS, espelho do
 * `backend_v2/src/modules/products/brands.js`.
 *
 * A lista é FECHADA: `organizations` SUPPLIER ativas com `assigned_brand`
 * (servida por `GET /products/brands`). O produto grava exatamente o
 * `assigned_brand`; o casamento ignora caixa e acento.
 */

/** Trim, espaços colapsados, maiúsculas pt-BR, acentos MANTIDOS. */
export function NormalizeBrandName(value) {
    return String(value ?? '')
        .trim()
        .replace(/\s+/g, ' ')
        .toLocaleUpperCase('pt-BR');
}

/** Chave de comparação: sem diacríticos e sem caixa ("Procão" = "PROCAO"). */
export function BrandMatchKey(value) {
    return NormalizeBrandName(value)
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '');
}

/**
 * Marca canônica (string EXATA da lista) que casa com `value`, ou null.
 * `brands` aceita strings ou `{ brand }` (o formato do `/products/brands`).
 */
export function ResolveCanonicalBrand(value, brands = []) {
    const key = BrandMatchKey(value);
    if (!key) {
        return null;
    }
    for (const item of brands) {
        const brand = typeof item === 'string' ? item : item?.brand;
        if (brand && BrandMatchKey(brand) === key) {
            return brand;
        }
    }
    return null;
}
